import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import Modal from 'Components/Modal';
import Icon from 'Components/Icon';
import History from 'Store/history';
import EnvironmentManager, { CMS_MESSAGES_READY_EVENT } from 'Utils/environmentManager';
import {
  getAutoDarkThemePopupContent,
  markAutoDarkThemePopupSeen,
  shouldShowAutoDarkThemePopup
} from 'Utils/theme';

const ThemeAutoDarkPopup = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [cmsTick, setCmsTick] = useState(0);
  const deviceType = useSelector(state => state.userAgent?.device?.type);
  const isMobileDevice = deviceType !== 'desktop';
  const content = useMemo(() => getAutoDarkThemePopupContent(isMobileDevice), [isMobileDevice, cmsTick]);

  useEffect(() => {
    const onMessagesReady = () => setCmsTick(tick => tick + 1);
    window.addEventListener(CMS_MESSAGES_READY_EVENT, onMessagesReady);
    if (EnvironmentManager.isLiveMessagesReady()) {
      onMessagesReady();
    }
    return () => window.removeEventListener(CMS_MESSAGES_READY_EVENT, onMessagesReady);
  }, []);

  useEffect(() => {
    if (EnvironmentManager.isLiveMessagesReady() && shouldShowAutoDarkThemePopup()) {
      setIsOpen(true);
    }
  }, [cmsTick]);

  const dismiss = () => {
    markAutoDarkThemePopupSeen();
    setIsOpen(false);
  };

  const goToSettings = () => {
    dismiss();
    const target = content.button1Deeplink;
    if (target.startsWith('/')) {
      History.push(target);
      return;
    }
    if (typeof window !== 'undefined') {
      window.location.assign(target);
    }
  };

  return (
    <Modal
      isOpen={ isOpen }
      onClose={ dismiss }
      centered
      modalSize="large"
      position={ { web: 'center', mobile: 'bottom' } }
      closeIconVisible={ isMobileDevice }
      showCloseOnBottom={ isMobileDevice }
      closeIconName="svgModalCloseX"
      disableOverlayClick
      lockBackgroundScroll
      className="theme-auto-dark-popup"
      buttonArea={ {
        primaryButton: {
          label: content.button2Text,
          className: 'btn--primary btn--half-round',
          onClick: dismiss
        },
        secondaryButton: {
          label: content.button1Text,
          className: 'btn--outline btn--half-round',
          onClick: goToSettings
        }
      } }
      buttonsReversed
    >
      <div className="theme-auto-dark-popup__content" data-test="theme-auto-dark-popup">
        <div className="theme-auto-dark-popup__icon-wrap">
          <Icon className="theme-auto-dark-popup__icon" iconName="svgInfoOutlineV2" />
        </div>
        <h2 className="theme-auto-dark-popup__title">{ content.title }</h2>
        <p className="theme-auto-dark-popup__text" dangerouslySetInnerHTML={ { __html: content.text } } />
      </div>
    </Modal>
  );
};

export default ThemeAutoDarkPopup;
